import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const lastIndex = items.length - 1;
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {item.to && index !== lastIndex ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className={index === lastIndex ? "font-medium text-foreground-800" : ""} aria-current="page">
              {item.label}
            </span>
          )}
          {index !== lastIndex && <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />}
        </span>
      ))}
    </nav>
  );
}